import { createIcon } from '@chakra-ui/react';

export const DollarCircled = createIcon({
  displayName: 'Dollar Circled',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect id="bg" width="24" height="24" fill="#fff" />
      <g id="SJ-Icon-B_Donate2_Red_RGB">
        <path
          id="Path_2165"
          data-name="Path 2165"
          d="M23.057,7.329A12.037,12.037,0,1,0,24,12,11.959,11.959,0,0,0,23.057,7.329ZM19.664,19.664A10.839,10.839,0,1,1,4.336,4.336,10.839,10.839,0,0,1,19.664,19.664Z"
          fill="currentColor"
        />
        <path
          id="Path_2166"
          data-name="Path 2166"
          d="M269.024,163.4a5.835,5.835,0,0,0-2.524-.9v-3.844a5.087,5.087,0,0,1,2.428,1.051.581.581,0,0,0,.714-.916,6.205,6.205,0,0,0-3.142-1.307v-1.136a.581.581,0,0,0-1.161,0v1.105l-.191.013a3.131,3.131,0,0,0-3.139,3,2.641,2.641,0,0,0,.885,2.06,4.632,4.632,0,0,0,2.446.994v4.055a4.837,4.837,0,0,1-2.639-1.218.581.581,0,0,0-.816.827,5.547,5.547,0,0,0,2.163,1.273,6.9,6.9,0,0,0,1.291.29v1.167a.581.581,0,1,0,1.161,0V168.8l.13-.007a4.745,4.745,0,0,0,2.378-.765,2.679,2.679,0,0,0,1.214-2.271A2.746,2.746,0,0,0,269.024,163.4Zm-5.855-2.934c0-1,.834-1.738,2.076-1.843l.093-.007v3.728C263.409,162,263.17,161.124,263.17,160.468Zm5.175,6.6a3.579,3.579,0,0,1-1.789.559l-.055,0v-3.955c2.278.4,2.561,1.359,2.561,2.075A1.524,1.524,0,0,1,268.344,167.071Z"
          transform="translate(-253.92 -151.13)"
          fill="currentColor"
        />
      </g>
    </>
  ),
});
